import { screenToTile } from '../iso/IsoMath';
/**
 * One depth-sorted thing in the world layer. The view is any Container
 * (a Sprite for props and walls, a paper-doll Container for characters).
 * `box` is in tile space; `left/top/right/bottom` is the view's world-screen
 * rect (logical px, before the camera) used for culling, sorting and picking.
 */
export class WorldItem {
    id;
    kind;
    view;
    box = { minX: 0, minY: 0, minZ: 0, maxX: 0, maxY: 0, maxZ: 0 };
    left = 0;
    top = 0;
    right = 0;
    bottom = 0;
    /** Result of the last cull pass. */
    onScreen = false;
    pickable = true;
    /** Owner object (Prop, Wall, Character) for game code. */
    owner = null;
    constructor(id, kind, view) {
        this.id = id;
        this.kind = kind;
        this.view = view;
    }
    setBox(minX, minY, minZ, maxX, maxY, maxZ) {
        const b = this.box;
        b.minX = minX;
        b.minY = minY;
        b.minZ = minZ;
        b.maxX = maxX;
        b.maxY = maxY;
        b.maxZ = maxZ;
    }
    setRect(left, top, right, bottom) {
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
const tmp = { x: 0, y: 0 };
/**
 * Exact hit test of a world-screen point against the iso silhouette of a
 * tile-space box. A screen point un-projects to the line
 * (A + z, B + z) for z in [minZ, maxZ], where (A, B) is its ground-plane
 * position; it hits the box iff that segment crosses the footprint.
 * `pad` (tiles) fattens thin boxes such as walls.
 */
export function boxContainsScreenPoint(b, wx, wy, pad = 0) {
    screenToTile(wx, wy, 0, tmp);
    const zLo = Math.max(b.minZ, b.minX - pad - tmp.x, b.minY - pad - tmp.y);
    const zHi = Math.min(b.maxZ, b.maxX + pad - tmp.x, b.maxY + pad - tmp.y);
    return zLo <= zHi;
}
